import { useSnackbar } from "notistack";
import { useRef } from "react";
import { ShareIcon } from "components/icons/solid";
import { copyToClipboard } from "lib/copyToClipboard";
import { Button } from "./Button";

interface CopyShareButtonProps {
    textToCopy?: string;
    className?: string;
}

export const CopyShareButton = ({ textToCopy, className }: CopyShareButtonProps) => {
    const buttonRef = useRef<HTMLButtonElement>(null);
    const { enqueueSnackbar } = useSnackbar();

    const handleCopy = async () => {
        const text = textToCopy || window.location.href;
        const success = await copyToClipboard(text);
        enqueueSnackbar(success ? "URL copied to clipboard" : "Error copying to clipboard", {
            variant: success ? "success" : "error",
        });
    };

    return (
        <Button
            variant="clean"
            ref={buttonRef}
            onClick={handleCopy}
            className={`gap-2 rounded-md px-3 text-sm text-[#424242] ring-0 ${className}`}
        >
            <ShareIcon className="h-4 w-4 text-gray-500 hover:text-gray-600" />
            Copy & Share
        </Button>
    );
};
